module.exports = "/fonts/Cabin-SemiBold.ttf";